$(function () {
    $('#services [data-service-preselect-form]').on('click', function (e) {
        const service = $(e.target).data('service-preselect-form');

        const $serviceCtaFormField = $('#contact-form #service-cta-field');

        if ($serviceCtaFormField.length) {
            $serviceCtaFormField.val(service)
        }
    });
});